module.exports = __webpack_public_path__ + "static/media/Deer_main_preview.74bff711.jpg";